export default {
  name: 'Toolbar',
  components: {},
  props: {},
  data: () => ({
    items: [
      {
        title: 'Dossier overview',
        path: '/dossier-overview',
      },
      {
        title: 'Input form',
        path: '/input-form',
      },
      {
        title: 'Product overview',
        path: '/product-overview',
      },
      {
        title: 'Unlinked inputs',
        path: '/unlinked-input-overview',
      },
      {
        title: 'Stakeholder overview',
        path: '/stakeholder-overview',
      },
      {
        title: 'Matches',
        path: '/matches',
      },
    ],
  }),
  computed: {},
  methods: {
    updateFilter(title) {
      if (title === 'Matches') {
        this.$eventHub.$emit('clear-search-input');
      }
    },
  },
};
